module.exports = __webpack_public_path__ + "assets/img/f298f68ebab0c2dd65bce58b2805e8f2.png";